<template lang="pug">
  .es-preload
    img.es-preload__img(alt="Logo expreso del sol" src="../assets/img/logo.png")
    <div class="preloader5">
      <span></span>
      <span></span>
      <span></span>
    </div>
 
</template>

<script>

export default {
  name: 'Preload',
    data () {
    return {

    }
  },
}
</script>
